"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
type Args = {
  pictures: string[];
  open: boolean;
  initialIndex: number;
  onClose: () => void;
  manageHistory?: boolean;
};
export function useImageLightbox(t0) {
  const $ = _c(31);
  const {
    pictures,
    open,
    initialIndex,
    onClose,
    manageHistory: t1
  } = t0;
  const manageHistory = t1 === undefined ? true : t1;
  const [index, setIndex] = useState(initialIndex);
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMounted(true);
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] !== initialIndex || $[3] !== open) {
    t4 = () => {
      if (open) {
        setIndex(initialIndex);
      }
    };
    t5 = [open, initialIndex];
    $[2] = initialIndex;
    $[3] = open;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const total = pictures.length;
  let t6;
  if ($[6] !== total) {
    t6 = () => {
      if (total === 0) {
        return;
      }
      setIndex(i => (i - 1 + total) % total);
    };
    $[6] = total;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const goPrev = t6;
  let t7;
  if ($[8] !== total) {
    t7 = () => {
      if (total === 0) {
        return;
      }
      setIndex(i_0 => (i_0 + 1) % total);
    };
    $[8] = total;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const goNext = t7;
  let t8;
  let t9;
  if ($[10] !== onClose || $[11] !== open || $[12] !== total) {
    t8 = () => {
      if (!open) {
        return;
      }
      const onKey = e => {
        if (e.key === "Escape") {
          e.stopPropagation();
          e.preventDefault();
          onClose();
        } else {
          if (e.key === "ArrowLeft") {
            if (total > 0) {
              setIndex(i_1 => (i_1 - 1 + total) % total);
            }
          } else {
            if (e.key === "ArrowRight") {
              if (total > 0) {
                setIndex(i_2 => (i_2 + 1) % total);
              }
            }
          }
        }
      };
      window.addEventListener("keydown", onKey, true);
      return () => window.removeEventListener("keydown", onKey, true);
    };
    t9 = [open, onClose, total];
    $[10] = onClose;
    $[11] = open;
    $[12] = total;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[15] !== open) {
    t10 = () => {
      if (!open) {
        return;
      }
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    };
    t11 = [open];
    $[15] = open;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  useEffect(t10, t11);
  const onCloseRef = useRef(onClose);
  let t12;
  let t13;
  if ($[18] !== onClose) {
    t12 = () => {
      onCloseRef.current = onClose;
    };
    t13 = [onClose];
    $[18] = onClose;
    $[19] = t12;
    $[20] = t13;
  } else {
    t12 = $[19];
    t13 = $[20];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[21] !== manageHistory || $[22] !== open) {
    t14 = () => {
      if (!open || !manageHistory) {
        return;
      }
      let closingViaPopstate = false;
      window.history.pushState({
        lightbox: true
      }, "");
      const handlePopstate = () => {
        closingViaPopstate = true;
        onCloseRef.current();
      };
      window.addEventListener("popstate", handlePopstate);
      return () => {
        window.removeEventListener("popstate", handlePopstate);
        if (!closingViaPopstate) {
          window.history.back();
        }
      };
    };
    t15 = [open, manageHistory];
    $[21] = manageHistory;
    $[22] = open;
    $[23] = t14;
    $[24] = t15;
  } else {
    t14 = $[23];
    t15 = $[24];
  }
  useEffect(t14, t15);
  let t16;
  if ($[25] !== goNext || $[26] !== goPrev || $[27] !== index || $[28] !== mounted || $[29] !== total) {
    t16 = {
      mounted,
      index,
      total,
      goPrev,
      goNext
    };
    $[25] = goNext;
    $[26] = goPrev;
    $[27] = index;
    $[28] = mounted;
    $[29] = total;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}